import { createContextService } from './ContextService.impl';

export const myContextService = createContextService();
